import React, { useState } from "react";
import { doc, serverTimestamp, setDoc } from "firebase/firestore";
import { useTranslation } from "react-i18next";
import { useAuth } from "../contexts/AuthContext";
import { db } from "../services/firebase";
import { SBS_LANGUAGES, normalizeSBSLanguage } from "../i18n";
import "./LanguageSwitcher.css";

export default function LanguageSwitcher({ compact = false }) {
  const { currentUser, refreshUserData } = useAuth();
  const { i18n, t } = useTranslation();
  const [saving, setSaving] = useState(false);
  const selectedLanguage = normalizeSBSLanguage(
    i18n.resolvedLanguage || i18n.language
  );

  const changeLanguage = async (event) => {
    const language = normalizeSBSLanguage(event.target.value);
    await i18n.changeLanguage(language);

    if (!currentUser?.uid) return;

    setSaving(true);
    try {
      await setDoc(
        doc(db, "users", currentUser.uid),
        { preferredLanguage: language, updatedAt: serverTimestamp() },
        { merge: true }
      );
      await refreshUserData();
    } catch (error) {
      console.warn("SBS language preference could not sync to the user profile.", error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <label className={`sbs-language-switcher ${compact ? "is-compact" : ""}`}>
      {!compact && <span>{t("language.label")}</span>}
      <select
        value={selectedLanguage}
        onChange={changeLanguage}
        aria-label={t("language.label")}
        disabled={saving}
      >
        {SBS_LANGUAGES.map((language) => (
          <option key={language.code} value={language.code}>
            {compact ? language.shortLabel : language.label}
          </option>
        ))}
      </select>
      {saving && <span className="sr-only">{t("language.saving")}</span>}
    </label>
  );
}
